import { navItems } from '@/modules/core/nav/store/nav.state';
import type { NavItem } from '@/modules/core/nav/models/NavItem';

export function getNavItems(): NavItem[] {
  return navItems.value;
}
